import React from "react";

export default function IEHeader() {
  return null;
}